type Listener = () => void;

interface ErrorModalSnapshot {
  isOpen: boolean;
  message?: string;
}

let state: ErrorModalSnapshot = { isOpen: false };
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((listener) => {
    listener();
  });
};

export const errorModalState = {
  getSnapshot: () => state,

  show: (message?: string) => {
    if (state.isOpen) return;
    state = { isOpen: true, message };
    notify();
  },

  hide: () => {
    state = { isOpen: false };
    notify();
  },

  subscribe: (listener: Listener) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
